/**
 * Follows the Unicode Normalization Form Canonical Decomposition (NFD) to strip diacritics (e.g., accents) from a string.
 * Reference: https://stackoverflow.com/a/37511463
 * 
 * @param {string} string string to strip diacritics from
 * @returns string without diacritics
 */
export const stripDiacritics = (string) => {
  return typeof string.normalize !== 'undefined'
    ? string.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    : string;
}
